import React, { useContext } from 'react'
import { Platform, Text, View } from 'react-native'
import { ThemeContext } from './utility/context/ThemeContext'
import ErrorAnimation from './utility/error-animation'
import useScreenSize from './utility/screen-size'
import { textStyles } from './style'
import { MAX_CONTENT_WIDTH } from './config'

function ErrorFallback(): JSX.Element {
  const theme = useContext(ThemeContext).theme
  const { bgMain, textMain } = theme.colors
  
  const { width } = useScreenSize()

  return (
    <View
      style={{
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: bgMain,
        gap: 8,
        maxWidth: MAX_CONTENT_WIDTH,
        alignSelf: 'center',
        paddingHorizontal: 16
      }}
    >
      <ErrorAnimation size={Math.min(width, 200)} />
      <Text style={[textStyles.body, { color: textMain, textAlign: 'center' }]}>
        {
          Platform.OS === 'web' ?
          "Uh oh! Looks like there's been an error on our end. To resolve, please try refreshing the page or closing and re-opening the application."
          :
          "Uh oh! Looks like there's been an error on our end. To resolve, please try closing and re-opening the application."
        }
      </Text>
      <Text style={[textStyles.body, { color: textMain, textAlign: 'center' }]}>
        Our team has been notified and will investigate the issue.
      </Text>
    </View>
  )
}

export default ErrorFallback